module.exports = __webpack_public_path__ + "static/media/five-days.6b87b794.png";